
export const MissingLicense = () => {
  return (
    <>
      User missing license to access this feature.
    </>
  )
}